export { TitleSection, type TitleSectionProps } from './TitleSection';

